import {
    CoachingType,
    GoalStatus,
    Opportunity,
    OpportunityStatus,
} from '../general';

import { OpportunityType } from './opportunity-type.model';

// TODO remove after oa.model is refactored
/** adjustOpportunity must be called after calling this */
export function determineOpportunityTypeByComponent(
    item: Opportunity,
    componentItem: Opportunity,
    current: OpportunityType,
): OpportunityType {
    if (
        item.goalStatusId === GoalStatus.CLOSED &&
        componentItem.goalStatusId === GoalStatus.CLOSED
    ) {
        return item.isOppActive && componentItem.isOppActive
            ? OpportunityType.CLOSED_STILL_OPP
            : OpportunityType.CLOSED_NOT_OPP;
    }
    if (
        item.isExpired &&
        componentItem.isExpired &&
        item.oppStatusId === OpportunityStatus.ACTIVE
    ) {
        return OpportunityType.MISSED;
    }
    if (
        item.goalStatusId === GoalStatus.PRE_APPROVAL ||
        (componentItem.parentMetricId === item.metricId &&
            (componentItem.goalStatusId === GoalStatus.PRE_APPROVAL ||
                componentItem.goalStatusId === GoalStatus.UPDATING))
    ) {
        return OpportunityType.PENDING;
    }
    return current !== OpportunityType.ACTIVE
        ? OpportunityType.COMPONENT
        : OpportunityType.ACTIVE;
}

/** determineOpportunityTypeByComponent should be called after calling this if the item has components/children */
export function determineOpportunityType(item: Opportunity): OpportunityType {
    if (
        (((item.isExpired && item.parentMetricId == null) ||
            item.approved === false) &&
            (item.oppStatusId === OpportunityStatus.ACTIVE ||
                item.coachTypeId === CoachingType.NON_OA)) ||
        (item.oppStatusId === OpportunityStatus.CLOSED &&
            item.coachTypeId === CoachingType.MISSED &&
            item.approved === false)
    ) {
        return OpportunityType.MISSED;
    }
    if (
        item.goalStatusId === GoalStatus.PRE_APPROVAL ||
        item.goalStatusId === GoalStatus.UPDATING
    ) {
        return OpportunityType.PENDING;
    }
    if (item.goalStatusId === GoalStatus.CLOSED) {
        return item.isOppActive
            ? OpportunityType.CLOSED_STILL_OPP
            : OpportunityType.CLOSED_NOT_OPP;
    }
    if (
        item.coachTypeId === CoachingType.UNCOACHED ||
        item.coachTypeId === CoachingType.NON_OPPORTUNITY
    ) {
        return OpportunityType.NO_GOAL;
    }
    if (item.coachTypeId === CoachingType.MISSED) {
        return OpportunityType.MISSED_EXPIRED;
    }
    return OpportunityType.ACTIVE;
}
